import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { AnimationOnScroll } from "vendors/react-animation-on-scroll";
import styles from "./styles.module.css";
function HappinessGuarantee(props) {
    return (_jsx(AnimationOnScroll, { animateIn: "animate__fadeIn", animateOnce: true, offset: 20, duration: 0.7, className: `${props.theme === "noline" ? styles.outernoline : styles.outer}`, children: _jsxs("div", { className: styles.inner, children: [_jsx("h3", { className: styles.heading, children: "Happiness Guarantee" }), _jsx("p", { className: styles.text, children: "Don\u2019t like your blend? We\u2019ll work with you to make it right and send you a new blend for free." })] }) }));
}
export default HappinessGuarantee;
